import { PRICE_DISCOVERY, PURCHASE_REQUEST_STATUS } from "../../../constants/seller-diy-constants";
import { DOCUMENTATION_STATUS, DocumentationInfo } from "./constant";

export const documentationStep = (priceDiscovery, purchaseRequestStatus) => {
    if (priceDiscovery === PRICE_DISCOVERY.ACCEPTED && purchaseRequestStatus === PURCHASE_REQUEST_STATUS.CREATED) {
        return DocumentationInfo[DOCUMENTATION_STATUS.PENDING];
    }
    return DocumentationInfo[DOCUMENTATION_STATUS.START];
};
